module.exports = __webpack_public_path__ + "img/電気回路_3_2_5.b9a61c0b.png";